<template>
  <div class="page" @scroll="scroll">
    <div>
      <div class="main">
        <div class="logo" v-if="data.logo">
          <img :src="data.logo" alt="">
        </div>
        <div class="title">{{ data.appIdDesc }}APP下载</div>
        <div class="qrcode" v-if="qrcode">
          <img :src="qrcode" alt="">
        </div>
        <div class="download" @click="clickDownload" v-if="data.details && data.details.length">下载安装</div>
        <div class="iconfont icon-xia" v-if="!toggleIcon" @click="scrollIntoView('.desc')"></div>
        <div class="iconfont icon-shang" v-if="toggleIcon" @click="scrollIntoView('.main')"></div>
      </div>

      <hr />

      <template v-if="data.brief">
        <div class="desc">
          <p class="title">应用简介</p>
          <p class="content">{{ data.brief }}</p>
        </div>

        <hr />
      </template>

      <template v-if="data.explain">
        <div class="desc">
          <p class="title">应用说明</p>
          <p class="content">{{ data.explain }}</p>
        </div>

        <hr />
      </template>

      <div class="screenshots" v-if="pictures && pictures.length">
        <p class="title">应用截图</p>
        <ul class="content">
          <li v-for="(item, index) in pictures" :key="index">
            <img :src="item" alt="">
          </li>
        </ul>
      </div>
    </div>
    <div class="wx-share-guide-mask" v-if="showMask" @click="showMask = false">
      <div class="wx-share-guide-image"></div>
      <div class="wx-share-guide-text">请点击右上角菜单选择在浏览器中打开</div>
    </div>
  </div>
</template>

<script>
import Weixin from "@/util/weixin";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getData(to.query.appid, to.query.redirect);
      vm.loadQrCode(to.query.appid)
    });
  },
  data() {
    return {
      data: {},
      showMask: false,
      toggleIcon: false,
      qrcode: null,
      pictures: []
    }
  },
  methods: {
    getData(appId, redirect) {
      var me = this,
        url = '/api/operation/sys_upapp/latestByAppid'
      me.$loading({
        url,
        params: {
          appId
        }
      }).then(function (res) {
        if (res.data) {
          document.title = res.data.appIdDesc + 'APP下载'
          me.data = res.data
          me.pictures = me.data.pictures ? JSON.parse(me.data.pictures) : []
          // iOS直接跳转AppStore
          if (res.data.details && res.data.details.length && !Weixin.isWeixin() && !Weixin.isWxWork()) {
            me.redirectDownload(res.data, redirect)
          }
        }
      });
    },
    /**
     * 直接跳转应用市场的场景
     */
    redirectDownload(app, redirect) {
      let ua = navigator.userAgent.toLowerCase(),
        isIphone = ua.match(/(iphone|ipod|ipad);?/i),
        isHuawei = ua.match(/(huawei);?/i),
        isHonor = ua.match(/(honor);?/i),
        isOppo = ua.match(/(poop|pacm00);?/i),
        isVivo = ua.match(/(vivo);?/i),
        isXiaomi = ua.match(/(mi\s|mix\s|redmi);?/i),
        isMeizu = ua.match(/(meizu);?/i);
      if (isIphone) {
        window.location = app.details[0].url
      } else if (isXiaomi && app.xiaomiMarket) {
        window.location = app.xiaomiMarket
      } else if (isHuawei && app.huaweiMarket) {
        window.location = app.huaweiMarket
      } else if (isHonor && app.honorMarket) {
        window.location = app.honorMarket
      } else if (isOppo && app.oppoMarket) {
        window.location = app.oppoMarket
      } else if (isVivo && app.vivoMarket) {
        window.location = app.vivoMarket
      } else if (isMeizu && app.meizuMarket) {
        window.location = app.meizuMarket
      } else if (redirect) {
        window.location = app.details[0].url
      }
    },
    loadQrCode(appId) {
      const me = this,
        link = window.location.origin + "/app_portal?appid=" + appId
      me.$ajax({
        url: "/api/commons/qrcode?url=" + encodeURIComponent(link),
        responseType: "blob",
      }).then(function (binaryData) {
        me.qrcode = URL.createObjectURL(binaryData);
      });
    },
    scroll(e) {
      this.toggleIcon = e.target.scrollTop / e.target.clientHeight > 0.5
    },
    clickDownload() {
      if (Weixin.isWeixin() || Weixin.isWxWork()) {
        this.showMask = true
      } else {
        this.redirectDownload(this.data, true)
      }
    },
    scrollIntoView(selector) {
      var desc = document.querySelector(selector)
      if (desc) {
        desc.scrollIntoView();
      }
    }
  }
}
</script>

<style scoped>
.page {
  background-color: var(--weui-BG);
}

.page .main {
  height: 100vh;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main .logo {
  border-radius: 5px;
  margin-top: 50px;
}

.logo img {
  width: 100px;
  height: 100px;
}

.main .title {
  color: var(--weui-FG);
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
}

.main .qrcode {
  flex: 1;
  display: flex;
  align-items: center;
}

.qrcode img {
  width: 200px;
  height: 200px;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid var(--weui-FG);
}

.main .download {
  width: 60%;
  height: 35px;
  border-radius: 5px;
  background-color: #07c160;
  text-align: center;
  line-height: 35px;
  color: #fff;
  font-size: 14px;
  margin-bottom: 50px;
}

.main .download:active {
  background-color: #06b050;
}

.main .iconfont {
  position: absolute;
  bottom: 0;
  width: 100%;
  font-size: 24px;
  color: var(--weui-FG-1);
  text-align: center;
}

.page .desc {
  padding: 30px;
}

.desc .title {
  font-size: 16px;
}

.desc .content {
  margin-top: 30px;
  font-size: 14px;
}

.page .screenshots {
  padding: 30px;
}

.screenshots .title {
  font-size: 16px;
}

.screenshots .content {
  overflow-x: scroll;
  margin-top: 30px;
  white-space: nowrap;
}

.screenshots .content li {
  display: inline-block;
  list-style: none;
  max-width: 200px;
  height: 300px;
  border: 1px solid;
  margin-right: 20px;
}

.screenshots .content li:last-child {
  margin-right: 0;
}

.screenshots .content img {
  width: 100%;
  height: 100%;
}

hr {
  margin: 0 10px;
}

.wx-share-guide-mask {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, .7);
  overflow: hidden;
  z-index: 10000;
}

.wx-share-guide-image {
  background-image: url(data:image/png;base64,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);
  background-position: center top;
  background-repeat: no-repeat;
  background-size: 100%;
  position: absolute;
  height: 300px;
  width: 280px;
  right: 28px;
  top: 5px;
  box-sizing: border-box;
  z-index: 900001;
}

.wx-share-guide-text {
  position: absolute;
  color: #eee;
  z-index: 900002;
  width: 260px;
  right: 10px;
  top: 180px;
  box-sizing: border-box;
  font-size: 15px;
}
</style>